import { render, staticRenderFns } from "./VLink.vue?vue&type=template&id=a7cf6582&scoped=true"
import script from "./VLink.vue?vue&type=script&lang=js"
export * from "./VLink.vue?vue&type=script&lang=js"
import style0 from "./VLink.vue?vue&type=style&index=0&id=a7cf6582&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7cf6582",
  null
  
)

export default component.exports